import { kea } from './kea';
import { resetCache } from './kea/cache';
import { clearReducerCache } from './kea/reducer';
import { clearActionCache } from './kea/actions/create';
import { clearActivatedPlugins } from './kea/plugins';

export { kea } from './kea';
export { keaReducer } from './kea/reducer';
export { createAction } from './kea/actions/create';

export { getStore } from './kea/store';

// for plugins
export { getCache, setCache } from './kea/cache';
export { activatePlugin } from './kea/plugins';

export var connect = function connect(mapping) {
  return kea({ connect: mapping });
};

export function resetKeaCache() {
  resetCache();
  clearActionCache();
  clearReducerCache();
  clearActivatedPlugins();
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/kea/es/index.js
// module id = 5
// module chunks = 0